import { EndpointSetting } from "@/constants/app/type";
import { TourState } from "../types";

export const callbackToursCollections: EndpointSetting['caller'] = (
  state: TourState,
  action: any,
  endpointName: any
) => {
  state.tours_collections.loading = false
  state.tours_collections.error = null
  state.tours_collections.success = true
  state.tours_collections.data = action.payload?.collections || []
  state.tours_collections.filter = {
    ...action.meta.arg,
    ...action.payload?.sorting,
    page: action.payload?.pagination?.currentPage || 1,
    limit: action.payload?.pagination?.limit || 20,
  }
}